import { isNonProduction } from '@/utilities/logger/datadog/vitals/vitalsStorage';
import './styles/version.scss';

/**
 * Renders the current build version in non-production environments only.
 * Hidden when running in production or when no build version is available.
 */
export const Version = () => {
  const buildVersion = process.env.BUILD_VERSION;

  if (!isNonProduction() || !buildVersion) {
    return null;
  }

  return (
    <div className="version-display" data-testid="version-display">
      Version: {buildVersion}
    </div>
  );
};

export default Version;
